import BeSimpleAPI from '@/providers/api/';
import i18n from '@/plugins/i18n';

import { baseActions } from './../base_actions'
import { baseMutations } from './../base_mutations'

const state =
{
    api: new BeSimpleAPI(process.env.VUE_APP_MANAGEMENT_API_URL),
    'companies': {
        items: [],
        item: {}
    },
    'administrations': {
        items: [],
        item: {},
        path: function(params) {
            return `companies/${params.companyId}/administrations`;
        },
        coupling: [
            { value: null, text: `--- ${i18n.t('management.kiesEenKoppeling')} ---` },
            { value: 'accountview', text: 'Accountview'},
            { value: 'afas', text: 'Afas' },
            { value: 'afas-online', text: 'Afas Online' },
            { value: 'alerterp', text: 'Alert ERP'},
            { value: 'baan', text: 'BAAN' },
            { value: 'csv', text: 'CSV' },
            { value: 'dummy', text: 'Dummy' },
            { value: 'eva', text: 'Eva' },
            { value: 'exact', text: 'Exact' },
            { value: 'cashflow', text: 'Cashflow' },
            { value: 'groenvision', text: 'GroenVision' },
            { value: 'groenvisionxml', text: 'GroenVisionXML' },
            { value: 'orderdirect', text: 'OrderDirect' },
            { value: 'king', text: 'KING' },
            { value: 'mamut', text: 'Mamut' },
            { value: 'minox', text: 'Minox' },
            { value: 'navision', text: 'Navision' },
            { value: 'orderdirect', text: 'OrderDirect' },
            { value: 'pakbon', text: 'Pakbon' },
            { value: 'prima', text: 'PRIMA' },
            { value: 'sapcsv', text: 'SAP CSV' },
            { value: 'snelstart_online', text: 'Snelstart Online' },
            { value: 'snelstartgateway', text: 'Snelstart Gateway' },
            { value: 'ubl', text: 'UBL' },
            { value: 'unit4', text: 'Unit4' },
            { value: 'unit4csv', text: 'Unit4Csv' },
            { value: 'werkexpert', text: 'WerkExpert' },
            { value: 'xml', text: 'XML' }
        ]
    },
    'users': {
        items: [],
        item: {},
        path: function(params) {
            return `companies/${params.companyId}/users`;
        }
    },
    'modules': {
        items: [],
        item: {},
        path: function(params) {
            return `companies/${params.companyId}/modules`;
        }
    }
}

const getters = {
    //List getters
    administrations: state => state['administrations'].items,
    coupling: state => state['administrations'].coupling,
    companies: state => state['companies'].items,
    users: state => state['users'].items,
    modules: state => state['modules'].items,
    
    //Single getters
    administration: state => state['administrations'].item,
    company: state => state['companies'].item,
    user: state => state['users'].item,
    module: state => state['modules'].item,
}

const actions = {
    ...baseActions
}

const mutations = {
    ...baseMutations
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}